export interface RecipientType {
  username: string;
  email: string | null;
  fullName: string | null;
}

export const mockRecipients: string[] = [
  'rickardelsen',
  'esafauzi',
  'cikabeliat',
  'ardipradiva',
  'cagardimikas',
];
